@if (!viewPassenger) {
  <div>
    <div class="theme-hero-text-title title-filter-list bg_filter _mb-0 text-center d-none">
      <h4 class="title-custom title_buscador _mt-0 mt-1 mb-1">{{title}}</h4>
    </div>
    @if (type == 0 || type == 1 || type == 5) {
      <div class="text-center d-none">
        <input class="search wd-90 d-none" placeholder="{{'barra_busqueda.escribe' | translate}}" (input)="getItems($event)" #autofocus
          [(ngModel)]="search" />
        </div>
      }
      @if (type == 2) {
        <div class="text-center">
          <div class="input-group input-group-merge">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-search">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </span>
            </div>
            <input type="text" (input)="getItems($event)" #autofocus id="fname-icon" name="fname-icon"
              placeholder="{{'barra_busqueda.buscarPasajero' | translate}}" class="form-control" />
            </div>
            <button data-toggle="modal" data-target=".editarRegistro" class="btn btn-outline-success waves-effect mt-2 mb-2"
              (click)="createPassager()">
              {{'barra_busqueda.nuevoPasajero' | translate}}
            </button>
          </div>
        }
        <!-- RESULTADO DE LA BUSQUEDA -->
        @if (type == 0 || type == 1 || type == 5) {
          <div class="p-0">
            @if (search && items.length === 0 ) {
              <ngb-alert  [type]="'warning'" [dismissible]="false">
                <h4 class="alert-heading">Ups!</h4>
                <div class="alert-body">
                  {{'barra_busqueda.noEncontramos' | translate}}
                </div>
              </ngb-alert>
            }
            @if ((search && muestra)) {
              <ul class="list-group list-group-flush mb-0 p-0">
                @for (item of items; track item) {
                  <li class="col-xs-12 list-group-item line-separator" (click)="eventSelect(item)">
                    <label class="fl_labelcity">
                      <!-- Aquí se muestran las sugerencias -->
                      <svg xmlns="http://www.w3.org/2000/svg"  width="1.5rem" height="1.5rem" viewBox="0 0 24 24"><path fill="black" d="M12 2c-4.42 0-8 .5-8 4v10a3 3 0 0 0 1 2.22V20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h6a8 8 0 0 1-1-3.5a5.55 5.55 0 0 1 2.38-4.5H6V6h12v4a4 4 0 0 1 .5 0a5.3 5.3 0 0 1 1.5.22V6c0-3.5-3.58-4-8-4M7.5 14A1.5 1.5 0 1 1 6 15.5A1.5 1.5 0 0 1 7.5 14m11-2a3.54 3.54 0 0 0-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5a3.54 3.54 0 0 0-3.5-3.5m0 4.8a1.2 1.2 0 1 1 0-2.4a1.29 1.29 0 0 1 1.2 1.2a1.15 1.15 0 0 1-1.2 1.2"/></svg>
                      {{ item.city.toString().split(",")[0]}}
                    </label>
                    <div class="fl_subcity">{{ item.city.toString().split(",")[1]}}</div>
                    <div class="fl_separator_div"></div>
                  </li>
                }
              </ul>
            }
            <!-- RESULTADOS SIN BUSQUEDA -->
            @if (!search) {
              <div class="_pb-mob-20">
                <div>
                  @if (!search && type != 1) {
                    <ul class="list-group list-group-flush mb-0 p-0">
                      @for (item of last; track item) {
                        <li class="col-xs-12 list-group-item line-separator-red "
                          (click)="searchCity(item)">
                          <label class="fl_labelcity">
                            <svg xmlns="http://www.w3.org/2000/svg"  width="1.5rem" height="1.5rem" viewBox="0 0 24 24"><path fill="black" d="M12 2c-4.42 0-8 .5-8 4v10a3 3 0 0 0 1 2.22V20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h6a8 8 0 0 1-1-3.5a5.55 5.55 0 0 1 2.38-4.5H6V6h12v4a4 4 0 0 1 .5 0a5.3 5.3 0 0 1 1.5.22V6c0-3.5-3.58-4-8-4M7.5 14A1.5 1.5 0 1 1 6 15.5A1.5 1.5 0 0 1 7.5 14m11-2a3.54 3.54 0 0 0-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5a3.54 3.54 0 0 0-3.5-3.5m0 4.8a1.2 1.2 0 1 1 0-2.4a1.29 1.29 0 0 1 1.2 1.2a1.15 1.15 0 0 1-1.2 1.2"/></svg>
                            {{ item }}
                          </label>
                          <div class="fl_subcity">{{ item.toString().split(",")[1]}}</div>
                          <div class="fl_separator_div"></div>
                        </li>
                      }
                    </ul>
                  }
                  @if (!search) {
                    <ul class="list-group">
                      <li class="list-group text-center mb-2" style="background-color: #EFF1F6;">
                        <p class="mt-1 mb-1">
                          {{'barra_busqueda.ciudadesMasBuscada' | translate}}
                        </p>
                      </li>
                    </ul>
                  }
                  <!-- MUESTRA LISTADO DE CIUDADES MAS BUSCADAS -->
                  @for (item of items_sel | slice:0:16; track item) {
                    <ul col-12 class="list-group list-group-flush mb-0 p-0">
                      @if (item.marca != 0) {
                        <li class="col-xs-12 list-group-item line-separator"
                          (click)="eventSelect(item)">
                          <label class=" fl_labelcity" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 24 24"><path fill="black" d="M12 2c-4.42 0-8 .5-8 4v10a3 3 0 0 0 1 2.22V20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h6a8 8 0 0 1-1-3.5a5.55 5.55 0 0 1 2.38-4.5H6V6h12v4a4 4 0 0 1 .5 0a5.3 5.3 0 0 1 1.5.22V6c0-3.5-3.58-4-8-4M7.5 14A1.5 1.5 0 1 1 6 15.5A1.5 1.5 0 0 1 7.5 14m11-2a3.54 3.54 0 0 0-3.5 3.5c0 2.6 3.5 6.5 3.5 6.5s3.5-3.9 3.5-6.5a3.54 3.54 0 0 0-3.5-3.5m0 4.8a1.2 1.2 0 1 1 0-2.4a1.29 1.29 0 0 1 1.2 1.2a1.15 1.15 0 0 1-1.2 1.2"/></svg>
                            {{ item.city.toString().split(",")[0]}}
                          </label>
                          <div class="fl_subcity">{{ item.city.toString().split(",")[1]}}
                          </div>
                          <div class="fl_separator_div"></div>
                        </li>
                      }
                    </ul>
                  }
                </div>
              </div>
            }
            @if (!search) {
              <h6 class="_mt-10"></h6>
            }
          </div>
        }
        @if (type == 2 || type == 3) {
          <div style="max-height: 480px; overflow-x: hidden;">
            @if (items.length == 0) {
              <div>
                <h5 style="font-weight: 300; text-align: center;">
                  {{'barra_busqueda.aunNoPasajeros' | translate}}
                </h5>
              </div>
            }
            <div>
              @for (item of items; track item) {
                <div class="employee-task d-flex justify-content-between align-items-center mb-1">
                  <div class="media">
                    <div class="avatar mr-75 bg-primary">
                      <div class="avatar-content">
                        {{ item.firstname.substring(0,1).toUpperCase( )
                        }}{{item.lastname.substring(0,1).toUpperCase( )}}
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <h6 class="mb-0 capitalice">
                        {{ item.firstname }} {{ item.lastname }}
                      </h6>
                      <small>{{ item.rut }}</small><br />
                      <small>{{ item.city }}, ({{ item.country }})</small><br />
                      <small>{{ item.email }}</small><br />
                      <small>{{ item.phone }}</small>
                      <br />
                      <button data-toggle="modal" data-target=".editarRegistro" type="button" (click)="editPassenger(item)"
                        style="margin-right: 5px;" class="btn btn-icon btn-outline-warning waves-effect">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-edit-3">
                          <path d="M12 20h9"></path>
                          <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                        </svg>
                      </button>
                      <button type="button" (click)="deleteTravelers(item)" data-target=".borrarRegistro"
                        class="btn btn-icon btn-outline-danger waves-effect">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-trash-2">
                          <polyline points="3 6 5 6 21 6"></polyline>
                          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                          <line x1="10" y1="11" x2="10" y2="17"></line>
                          <line x1="14" y1="11" x2="14" y2="17"></line>
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div>
                      <button class="btn btn-flat-success waves-effect active" (click)="selectPassenger(item)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-check">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              }
              <!--/ member's list  -->
            </div>
          </div>
        }
      </div>
    }

    @if (viewPassenger) {
      <app-crear-pasajeros [obj]="element" [edit]="edit" (eventEmit)="onEmit($event)"
        (eventClose)="onClose($event)" [modal]="true">
      </app-crear-pasajeros>
    }
